import { render } from "./AdminPromotions.vue?vue&type=template&id=4b98591f&scoped=true"
import script from "./AdminPromotions.vue?vue&type=script&lang=js"
export * from "./AdminPromotions.vue?vue&type=script&lang=js"

import "./AdminPromotions.vue?vue&type=style&index=0&id=4b98591f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b98591f"]])

export default __exports__